import { APP_PATHS } from '@/app/routes/paths';

export function getPostAuthRedirect(state: unknown): string {
  if (!state || typeof state !== 'object' || !('from' in state)) return APP_PATHS.feed;

  const from = (state as { from?: unknown }).from;
  return typeof from === 'string' && from.startsWith('/') && !from.startsWith('//')
    ? from
    : APP_PATHS.feed;
}
